import { useSnackbar } from 'notistack';
import {
  Tag, TagType,
} from 'lib/types/tags';
import { Post } from 'lib/types';
import { useApi } from 'lib/contexts/ApplicationState';
import { TagsDisplay } from './TagsDisplay';

interface Props {
  post: Post;
  tagTypes: TagType[];
  onChange: () => void;
}

export const PostTags = ({ post, tagTypes, onChange }: Props) => {
  const API = useApi();
  const { enqueueSnackbar } = useSnackbar();

  const createTag = async (tagValue: Tag) => {
    try {
      await API.addTagToPost(
        post.id, tagValue?.tagTypeId, tagValue?.value, tagValue?.id,
      );
    } catch (error: any) {
      enqueueSnackbar(`There was an error: ${error.message}`, { variant: 'error' });
    }
    onChange();
  };

  const removeTag = async (tagValue: Tag) => {
    try {
      await API.deleteTagFromPost(post.id, tagValue.id);
    } catch (error) {
      enqueueSnackbar('There was an error deleting the tag.  Please try again later.', { variant: 'error' });
    }
    onChange();
  };

  return (
    <TagsDisplay
      tagTypes={tagTypes}
      tags={post.tags || []}
      onRemoveTag={removeTag}
      onSelectTag={createTag}
      postId={post.id}
    />
  );
};
